import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ListTree: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M21 12h-8' }],
    ['path', { d: 'M21 6H8' }],
    ['path', { d: 'M21 18h-8' }],
    ['path', { d: 'M3 6v4c0 1.1.9 2 2 2h3' }],
    ['path', { d: 'M3 10v6c0 1.1.9 2 2 2h3' }],
  ],
];

export default ListTree;
